<mat-card class="notification-card">
    <div class="card-header">
        <button *ngIf="showSaveButton" id="profile-form-submit" class="button profile-button" mat-button (click)="saveProfile()">Save Changes</button>
        <mat-card-title><h2>Notifications</h2></mat-card-title>
        <p>How would you like to receive notifications?</p>
        <mat-card-subtitle *ngIf="showSaveButton">Manage your notifications</mat-card-subtitle>
        <div class="underline"></div>
    </div>
    <mat-card-content>
        <form>
            <mat-radio-group
                style="margin-bottom: 2rem"
                class="d-flex"
                [(ngModel)]="notificationType"
                [ngModelOptions]="{ standalone: true }"
                (ngModelChange)="onChange($event)"
            >
                <mat-radio-button
                    style="margin-right: 2rem"
                    *ngFor="let notification of notificationTypesKeys | keyvalue"
                    [value]="notification.value"
                    [checked]="notification.key === notificationType"
                >
                    {{ notificationTypes[notification.key] }}
                </mat-radio-button>
            </mat-radio-group>
        </form>
    </mat-card-content>
</mat-card>
